export class Item {
  constructor(public readonly name: string,
              public readonly value: any,
              public readonly isPhoneNumber?: boolean,
              public readonly isState?: boolean,
              public readonly isLink?: boolean,
              public readonly hasBtn?: boolean,
              public readonly btnName?: string) {
  }
}